import { Relation } from './Relation';
function hasOwnValues(stmt, node) {
    return stmt.params.get(node.id) !== undefined;
}
function getOwnValues(stmt, node) {
    var _a;
    return Array.from((_a = stmt.params.get(node.id)) !== null && _a !== void 0 ? _a : []);
}
function setOwnValues(stmt, node, values) {
    const params = stmt.params;
    if (values.length) {
        params.set(node.id, values);
    }
    else {
        params.delete(node.id);
    }
    return {
        ...stmt,
        params,
    };
}
function setNodeParams(stmt, node, values, source) {
    var _a;
    if (source === '?') {
        const len = values.length;
        if (len !== 1) {
            throw new Error(`cannot set ordinal refs for multi-param nodes: ` +
                JSON.stringify({
                    values: values.slice(0, 5),
                    source,
                }));
        }
        const val = values[0];
        const key = val == null ? null : val.valueOf();
        const ord = (_a = stmt.oparams.get(key)) !== null && _a !== void 0 ? _a : stmt.oparams.size + 1;
        stmt.oparams.set(key, ord);
        source = `$${ord}`;
    }
    stmt = setOwnValues(stmt, node, values);
    stmt = setFragment(stmt, node, source);
    return stmt;
}
function getFragment(stmt, node) {
    return stmt.fragments.get(node.id);
}
function setFragment(stmt, node, source) {
    const fragments = stmt.fragments;
    fragments.set(node.id, source);
    return {
        ...stmt,
        fragments,
    };
}
export var Fragment;
(function (Fragment) {
    Fragment.get = getFragment;
    Fragment.set = setFragment;
    function getExpr(stmt, node, api) {
        const fragment = getFragment(stmt, node);
        if (fragment == null) {
            return fragment;
        }
        switch (node.type) {
            case "STRING_LITERAL":
            case "NUMBER_LITERAL":
            case "BOOLEAN_LITERAL":
            case "DATE_TIME_LITERAL":
                return api.castValue(fragment, node.data.type);
            default:
                return fragment;
        }
    }
    Fragment.getExpr = getExpr;
    function setParam(stmt, node, value, source = '?') {
        return setNodeParams(stmt, node, [value], source);
    }
    Fragment.setParam = setParam;
    function setParams(stmt, node, values, source) {
        return setNodeParams(stmt, node, values, source);
    }
    Fragment.setParams = setParams;
    function popParams(stmt, node) {
        const values = [];
        const params = new Map(stmt.params);
        throw new Error('popParams is currently unsupported in combination with ordinal params (eg. $1)');
        Relation.reduce(null, node, (_, node) => {
            if (hasOwnValues(stmt, node)) {
                values.push(...getOwnValues(stmt, node));
                params.delete(node.id);
            }
        });
        return {
            values,
            stmt: {
                ...stmt,
                params,
            },
        };
    }
    Fragment.popParams = popParams;
    function getParams(stmt, node) {
        return Relation.reduce([], node, (values, node) => {
            if (hasOwnValues(stmt, node)) {
                return [...values, ...getOwnValues(stmt, node)];
            }
            else {
                return values;
            }
        });
    }
    Fragment.getParams = getParams;
})(Fragment || (Fragment = {}));
